import React from "react";
import Faq from "./Faq";
import "./Momgift.css";
function Momgift() {
  return (
    <>
      <div className="ab__1">
        <h4 className="as">The Best Mother’s Day Gifts for 2022</h4>

        <div className="data">
          <div id="content">
            <h5>Get It Fast With Expedited Shipping</h5>
            <h5 className="t">
              Order by 9AM PT on 5/4 for two-day shipping, or by 9AM PT on 5/5
              for next-day shipping.
            </h5>
          </div>
        </div>
      </div>
    </>
  );
}

function Therealdeal() {
  return (
    <>
      <div className="thedeal">
        <img
          src="https://n.nordstrommedia.com/id/83ae8a49-2bec-475b-8ff9-89102434a25b.jpeg?h=519&w=1334"
          alt=""
        />
      </div>
      <div className="g">
        <div id="q">
          <div className="iq">
            <p>She'll feel like a million bucks. </p>
            <a href="">Shop Now</a>
          </div>
        </div>
        <div id="w">
          <div className="iq">
            <p>Big statements. Small prices. </p>
            <a href="">Shop Now</a>
          </div>
        </div>
      </div>

      <div className="thedeal">
        <img
          src="	https://n.nordstrommedia.com/id/cfc9a145-8ed8-4655-bfe6-97ddc4045842.jpeg?h=719&w=1334"
          alt=""
        />
      </div>

      <div className="old">
        <div className="se">
          <img
            src="https://n.nordstrommedia.com/id/34ba3714-658a-4220-8145-569805d0bd4c.jpeg?h=480&w=308"
            alt=""
          />
          <h5> She's a Gem</h5>
          <p>Get her something sparkly.</p>
          <a href="" style={{ color: "skyblue" }}>
            Jewelry & Watch Gifts
          </a>
        </div>
        <div id="middle"> </div>
        <div className="se">
          <img
            src="	https://n.nordstrommedia.com/id/5d23a5bc-0400-4019-99a7-bb88c30eda2e.jpeg?h=480&w=308"
            alt=""
          />
          <h5> She's a Gem</h5>
          <p>Get her something sparkly.</p>
          <a href="" style={{ color: "skyblue" }}>
            Jewelry & Watch Gifts
          </a>
        </div>
      </div>

      <div className="ugift">
        <div className="h">
          <img
            src="https://n.nordstrommedia.com/id/54d7450b-b0f2-4fda-b87e-66fafe98df31.jpeg?h=555&w=650"
            alt=""
          />
          <p>Because she's one of a kind.</p>
          <a href="">Unique Gifts from $20</a>
          <div></div>
        </div>
        <div className="h">
          <img
            src="https://n.nordstrommedia.com/id/d668970f-eeff-4ba4-b9a1-3f5cb6953fe7.jpeg?h=555&w=650"
            alt=""
          />
          <p>To make her space as special as she is.</p>
          <a href="">Gifts for the Home Up to 65% Off</a>
        </div>
      </div>

     

      <div className="thedeal">
        <img
          src="https://n.nordstrommedia.com/id/2e6dc5c1-f0bf-4edb-8327-6764423daefb.jpeg?h=600&w=1337"
          alt=""
        />
      </div>

      <div className="ugift" style={{ gap: "50px" }}>
        <div className="h">
          <img
            src="https://n.nordstrommedia.com/id/b23d395c-7216-4fd2-9aaa-c35623cc9d89.jpeg?h=555&w=650"
            alt=""
          />

          <h4 className="pt">Gift Cards & eGift Cards</h4>
          <p>Guaranteed to be a perfect fit.</p>

          <a href="" style={{ color: "skyblue" }}>
            Shop Now
          </a>
          <div></div>
        </div>
        <div className="h">
          <img
            src="	https://n.nordstrommedia.com/id/608d4683-f4f1-4f42-8571-591c846bcddd.jpeg?h=555&w=650"
            alt=""
          />

          <h4 className="pt">
            For holidays, birthdays, anniversaries or just because.
          </h4>
          <p> For holidays, birthdays, anniversaries or just because.</p>

          <a href="" className="colo" style={{ color: "skyblue" }}>
            All Gifts{" "}
          </a>
          <a href="" className="colo" style={{ color: "skyblue" }}>
            Gifts
          </a>
          <a href="" className="colo" style={{ color: "skyblue" }}>
            HerGifts{" "}
          </a>
          <a href="" className="colo" style={{ color: "skyblue" }}>
            {" "}
            HimGifts{" "}
          </a>
          <a href="" className="colo" style={{ color: "skyblue" }}>
            {" "}
            Kids
          </a>
        </div>
      </div>

      <div className="fpink">
        <div>
          <a href="" className="colo" style={{ color: "white" }}>
            Gifts Under $25{" "}
          </a>
          <a href="" className="colo" style={{ color: "white" }}>
            Gifts Under $50
          </a>
          <a href="" className="colo" style={{ color: "white" }}>
            {" "}
            Jewelry & Watch Gifts{" "}
          </a>
          {/* <a href=""  className="colo" style={{color:""}}> HimGifts </a>
           <a href=""  className="colo" style={{color:""}}>  Kids</a> */}
          <br />
          <br />
          <a href="" className="colo" style={{ color: "white" }}>
            {" "}
            Luxe & Designer Gifts{" "}
          </a>
          <a href="" className="colo" style={{ color: "white" }}>
            Wellness Gifts
          </a>
          <a href="" className="colo" style={{ color: "white" }}>
            {" "}
            Unique Gifts{" "}
          </a>
          <a href="" className="colo" style={{ color: "white" }}>
            {" "}
            HimGifts{" "}
          </a>
          <a href="" className="colo" style={{ color: "white" }}>
            {" "}
            Gifts for the Home
          </a>
          <br />
        </div>
      </div>

      <br />
    </>
  );
}

function Motherfaq() {
  return (
    <>
      <br />

      <Faq />
    </>
  );
}

export { Motherfaq };
export { Therealdeal };
export default Momgift;